/** Hidden Telegram Mini App route (not in public nav). */
export const TELEGRAM_BOT_PATH = "/telegram-bot";

/** Browser SEO guide — normal site chrome, not the Mini App shell. */
export const TELEGRAM_BOT_LEARN_MORE_PATH = "/telegram-bot/learn-more";

function normalizeTelegramPath(pathname) {
  if (!pathname || typeof pathname !== "string") return "";
  const cleaned = pathname.split("?")[0].split("#")[0];
  if (cleaned === "/") return "/";
  return cleaned.endsWith("/") ? cleaned.slice(0, -1) : cleaned;
}

export function isTelegramBotLearnMorePath(pathname) {
  return normalizeTelegramPath(pathname) === TELEGRAM_BOT_LEARN_MORE_PATH;
}

export function isTelegramBotPath(pathname) {
  const normalized = normalizeTelegramPath(pathname);
  if (!normalized) return false;
  if (isTelegramBotLearnMorePath(normalized)) return false;
  return (
    normalized === TELEGRAM_BOT_PATH ||
    normalized.startsWith(`${TELEGRAM_BOT_PATH}/`)
  );
}

/** Routes where bot cards should poll gas/status like /dashboard. */
export function isDashboardLikePath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return (
    pathname === "/dashboard" ||
    pathname.startsWith("/dashboard/") ||
    isTelegramBotPath(pathname)
  );
}
